import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
// @mui
import { alpha } from '@mui/material/styles';
import {
    Box,
    Divider,
    Typography,
    Stack,
    MenuItem,
    Avatar,
    IconButton,
    Popover
} from '@mui/material';
import i18n from '../../../i18n';
//
import ProfileDialog from '../../../pages/dialogs/ProfileDialog';
import ChangePasswordDialog from '../../../pages/dialogs/ChangePasswordDialog';
import { useStateSelector } from '../../../context/StateSelectors';

// ----------------------------------------------------------------------

const MENU_OPTIONS = [
    {
        id: 'home',
        label: 'profile.home',
        icon: 'eva:home-fill',
        url: '/app/dashboard'
    },
    {
        id: 'profile',
        label: 'profile.profile',
        icon: 'eva:person-fill'
    },
    {
        id: 'changePassword',
        label: 'text.changePassword',
        icon: 'eva:credit-card-outline'
    }
];

const UsersHead = [
    { id: 'firstName', label: 'firstName', alignRight: false, cell: 'Text' },
    { id: 'lastName', label: 'lastName', alignRight: false, cell: 'Text' },
    { id: 'gender', label: 'gender', alignRight: false, cell: 'Items', items: ['male', 'female', 'other'] },
    { id: 'birthDate', label: 'birthDate', alignRight: false, cell: 'Date' },
    { id: 'twoFactorEnabled', label: 'twoFactorEnabled', alignRight: false, cell: 'Dialog2FA' },
];

//-----------------------------------------------------------------------------
export default function AccountPopover() {
    const server = useStateSelector((state) => state.server);
    const userInfo = useStateSelector((state) => state.userInfo);

    const navigate = useNavigate();

    const [open, setOpen] = useState(null);
    const [profileDialogOpen, setProfileDialogOpen] = useState(false);

    const [passDialogOpen, setPassDialogOpen] = useState(false);

    const openChangePassDialog = (event) => setPassDialogOpen(event);
    const closeChangePassDialog = () => setPassDialogOpen(false);

    const handleOpen = (event) => setOpen(event.currentTarget);
    const handleClose = () => setOpen(null);

    const handleLogout = () => {
        server.auth.logoutUser();
        navigate('/login', { replace: true });
    };

    const handleRedirect = (option) => {
        if (option.url) {
            handleClose();
            navigate(option.url, { replace: true });
        }
        if (option.id === 'profile') {
            handleClose();
            setProfileDialogOpen(true);
        } else if (option.id === 'changePassword') {
            handleClose();
            openChangePassDialog(true);
        }
    };


    const currentUserData = userInfo ? userInfo : {};
    // leave only field that are in UsersHead
    const filteredUserData = Object.keys(currentUserData)
        .filter((key) => UsersHead.some((head) => head.id === key))
        .reduce((obj, key) => {
            obj[key] = currentUserData[key];
            return obj;
        }, {});

    return (
        <>
            <IconButton
                onClick={handleOpen}
                sx={{
                    p: 0,
                    ...(open && {
                        '&:before': {
                            zIndex: 1,
                            content: "''",
                            width: '100%',
                            height: '100%',
                            borderRadius: '50%',
                            position: 'absolute',
                            bgcolor: (theme) =>
                                alpha(theme.palette.grey[900], 0.8)
                        }
                    })
                }}
            >
                <Avatar alt="AB" sx={{ width: 44, height: 44 }} />
            </IconButton>

            <Popover
                open={Boolean(open)}
                anchorEl={open}
                onClose={handleClose}
                anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
                transformOrigin={{ vertical: 'top', horizontal: 'right' }}
                PaperProps={{
                    sx: {
                        "p": 0,
                        "mt": 1.5,
                        "ml": 0.75,
                        "width": 180,
                        '& .MuiMenuItem-root': {
                            typography: 'body2',
                            borderRadius: 0.75
                        }
                    }
                }}
            >
                <Box sx={{ my: 1.5, px: 2.5 }}>
                    <Typography variant="subtitle2" noWrap>
                        {`${userInfo?.firstName} ${userInfo?.lastName}`}
                    </Typography>
                    <Typography
                        variant="body2"
                        sx={{ color: 'text.secondary' }}
                        noWrap
                    >
                        {userInfo?.email}
                    </Typography>
                </Box>

                <Divider sx={{ borderStyle: 'dashed' }} />

                <Stack sx={{ p: 1 }}>
                    {MENU_OPTIONS.map((option) => (
                        <MenuItem
                            key={option.label}
                            onClick={() => handleRedirect(option)}
                        >
                            {i18n.t(option.label)}
                        </MenuItem>
                    ))}
                </Stack>

                <Divider sx={{ borderStyle: 'dashed' }} />

                <MenuItem onClick={handleLogout} sx={{ m: 1 }}>
                    {i18n.t('profile.logout')}
                </MenuItem>
            </Popover>

            <ProfileDialog
                dialogOpen={profileDialogOpen}
                dialogData={filteredUserData}
                Head={UsersHead}
                onSave={(data) => {
                    setProfileDialogOpen(false);
                }}
                onClose={() => setProfileDialogOpen(false)}
            />
            <ChangePasswordDialog
                open={passDialogOpen}
                onClose={closeChangePassDialog}
                userId={userInfo?.id}
            />
        </>
    );
}
